import { Browser } from "../utils/Browser";
export class HTMLCanvas {
    constructor(createCanvas) {
        if (createCanvas == null || createCanvas)
            this.source = Browser.createElement("canvas");
    }
    clear() {
        if (this.source)
            this.context.clearRect(0, 0, this.source.width, this.source.height);
    }
    get context() {
        return this._ctx || (this._ctx = this.source.getContext('2d'));
    }
    set context(value) {
        this._ctx = value;
    }
    size(w, h) {
        if (this.source) {
            this.source.height = h;
            this.source.width = w;
        }
    }
}
